@if (timer | async; as timer) {
  <app-timer
    [timer]="timer"
    [workForm]="workForm"
    [projectSummaries]="projectSummaries"
    [positionSummaries]="positionSummaries"
    [editingTimeEntryId]="editingTimeEntryId"
    [timeEntryError]="timeEntryError"
    [savingTimeEntryId]="savingTimeEntryId"
    (navigateBack)="navigateBack()"
    (start)="start()"
    (stop)="stop()"
    (delete)="delete()"
    (saveWork)="saveWork()"
    (beginTimeEntryEdit)="beginTimeEntryEdit($event)"
    (cancelTimeEntryEdit)="cancelTimeEntryEdit()"
    (updateTimeEntry)="updateTimeEntry($event)"
    (updateActiveStartTime)="updateActiveStartTime($event)"
  ></app-timer>
}
